"use strict";

exports.__esModule = true;
exports.position = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _core = require("../core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function positiveOrNegative(scale, path) {
  if (!(0, _isNumber["default"])(path)) {
    if ((0, _isString["default"])(path) && path.startsWith('-')) {
      var raw = path.slice(1);

      var _value = (0, _lodash["default"])(scale, raw, raw);

      if ((0, _isNumber["default"])(_value)) {
        return _value * -1;
      }

      return "-" + String(_value);
    }

    return (0, _lodash["default"])(scale, path, path);
  }

  var isNegative = path < 0;
  var abs = Math.abs(path);
  var value = (0, _lodash["default"])(scale, abs, abs);

  if ((0, _isNumber["default"])(value)) {
    return value * (isNegative ? -1 : 1);
  }

  if (value == null) {
    return;
  }

  return isNegative ? "-" + String(value) : value;
}

var config = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    transform: positiveOrNegative
  },
  right: {
    property: 'right',
    scale: 'space',
    transform: positiveOrNegative
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    transform: positiveOrNegative
  },
  left: {
    property: 'left',
    scale: 'space',
    transform: positiveOrNegative
  }
};
config.pos = config.position;
var position = (0, _core.system)(config);
exports.position = position;